
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40","x":"7","y":"9"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.29 6.58v-.85a1 1 0 00-.94-.94l-5.66-.07A.92.92 0 0011 5l-8.24 8.23a1 1 0 000 1.34l5.73 5.73a1 1 0 001.34 0l8.24-8.24a.89.89 0 00.27-.65h.81c1.79 0 3.34-.49 3.55-1.62.3-1.46-2.04-2.73-4.41-3.21zm-1.2 3.66a12 12 0 01-1.72-.47 1.52 1.52 0 11.54-.88 9.47 9.47 0 001.37.37c.35.06.7.1 1 .13V7.62c2.23.49 3.51 1.49 3.42 2s-1.41.95-3.38.77z"}})])
          )
        }
      }
    